import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UpdateFieldComponent } from './update-field.component';

export enum ActionTypes {
  fixed = 'fixed',
  docusign = 'docusign',
  dateSent = 'dateSent',
  dateSaved = 'dateSaved',
}

export enum TargetTypes {
  string = 'string',
  number = 'number',
  date = 'date',
}

export type UpdateFieldAction = {
  id: string;
  type: string;
  properties: {
    namespace: string;
    actionType: ActionTypes;
    fields: any;
    // key: field name, value: value or thymeleaf expression
    // eg { customText39: "testValue", status: "xyz" }
    // eg { customDate1: "[(${#temporals.format(docusign.formData.items.dataLabel_abc123, 'MM/dd/yyyy')})]" }
    targetTypes: any;
    // UI - target type. Two purposes:
    //  1. frontend: used for generating the thymeleaf expression
    //  2. backend: ActionConfigExecutorService coerces field values after Thymeleaf rendering — currently a "date" entry
    //     causes a millis-string or ISO string to be converted to a Long epoch millis before the action is dispatched.
    // key: field name, value: field type.
    // eg { customText39: "date" }
    sourcePaths: any;
    // UI - path to value in model
    // key: field name, value: field type.
    // eg { customText39: "docusign.formData.dataLabel1" }
  };
};

@Injectable({ providedIn: 'root' })
export class UpdateFieldService {
  static isAction(action: any): boolean {
    return action.id.endsWith(UpdateFieldComponent.NAME);
  }

  static createFormGroup(namespace: string, action?: any) {
    action = this.create(namespace, action);
    return new FormGroup({
      id: new FormControl(action.id, Validators.required),
      type: new FormControl(action.type, Validators.required),
      properties: new FormGroup({
        namespace: new FormControl(action.properties?.namespace, Validators.required),
        actionType: new FormControl(action.properties?.actionType, Validators.required),
        fields: new FormControl(action.properties?.fields),
        targetTypes: new FormControl(action.properties?.targetTypes),
        sourcePaths: new FormControl(action.properties?.sourcePaths),
      }),
    });
  }

  static create(namespace: string, existing?: UpdateFieldAction): UpdateFieldAction {
    return {
      id: existing?.id ?? `${namespace}.${UpdateFieldComponent.NAME}`,
      type: existing?.type ?? 'update',
      properties: {
        namespace: existing?.properties?.namespace ?? namespace,
        actionType: existing?.properties?.actionType ?? ActionTypes.fixed,
        fields: existing?.properties?.fields ?? {},
        targetTypes: existing?.properties?.targetTypes ?? {},
        sourcePaths: existing?.properties?.sourcePaths ?? {},
      },
    };
  }
}
